'use client';

import { createContext } from 'react';

import type { PageContextInterface } from '../types/page-root.types';

export const PageContext = createContext<PageContextInterface>({});

PageContext.displayName = 'Page.Context';
